import { gpHome } from '../../../app';
import {
    LicenseTypeDefinition,
    PersonalSubscriptionUpsertRequest,
    SubscriptionSummary,
} from '../../../services/subscription-management-contract';
import personalSubscriptionsTemplate from './personal-subscriptions.html';

interface PersonalSubscriptionsBindings {
    subscriptions: SubscriptionSummary[];
    licenseTypes: LicenseTypeDefinition[];
    onUpsert: (locals: { request: PersonalSubscriptionUpsertRequest }) => ng.IPromise<any>;
    onCancel: (locals: { subscriptionId: string }) => ng.IPromise<any>;
}

class PersonalSubscriptionsController implements PersonalSubscriptionsBindings {
    static $inject = ['$scope'];

    subscriptions: SubscriptionSummary[] = [];
    licenseTypes: LicenseTypeDefinition[] = [];
    onUpsert: (locals: { request: PersonalSubscriptionUpsertRequest }) => ng.IPromise<any>;
    onCancel: (locals: { subscriptionId: string }) => ng.IPromise<any>;

    newSubscription: PersonalSubscriptionUpsertRequest = {
        planCode: '',
        planName: '',
        seatsPurchased: 1,
        licenseTypeKey: '',
        autoRenews: true,
    };

    save(subscription: SubscriptionSummary) {
        const request: PersonalSubscriptionUpsertRequest = {
            subscriptionId: subscription.id,
            planCode: subscription.planCode,
            planName: subscription.planName,
            seatsPurchased: subscription.seatsPurchased,
            licenseTypeKey: subscription.licenseTypeKey,
            autoRenews: subscription.autoRenews,
        };
        return this.onUpsert({ request });
    }

    create() {
        if (!this.newSubscription.planCode) {
            return;
        }
        const request = { ...this.newSubscription };
        this.onUpsert({ request }).then(() => {
            this.newSubscription = {
                planCode: '',
                planName: '',
                seatsPurchased: 1,
                licenseTypeKey: '',
                autoRenews: true,
            };
        });
    }

    cancel(subscriptionId: string) {
        return this.onCancel({ subscriptionId });
    }
}

gpHome.directive('gpPersonalSubscriptions', [
    function () {
        return {
            restrict: 'E',
            scope: {
                subscriptions: '=',
                licenseTypes: '=',
                onUpsert: '&',
                onCancel: '&',
            },
            controller: PersonalSubscriptionsController,
            controllerAs: '$ctrl',
            bindToController: true,
            template: personalSubscriptionsTemplate,
        };
    }
]);
